import React, { useEffect, useMemo, useState } from 'react';
import { AppContext } from '../provider/AppContextProvider';
import { AdInformationInterface } from '../helper/PageInformationInterface';


declare global {
  interface Window {
    traffective: any;
  }
}

interface TraffectiveDataProps {
  adInformation: AdInformationInterface
}
export default function TraffectiveData(props: TraffectiveDataProps) {
  const { cmpReady, adsReady } = React.useContext(AppContext);
  const [callbackFired, setCallbackFired] = useState(false);

  
  const traffectiveConf = useMemo(() => {
    const zone = props?.adInformation?.targeting?.find(m => m.key == "zone")
    const pagetype = props?.adInformation?.targeting?.find(m => m.key == "pagetype")
    let json = JSON.stringify({
      // "targeting": [
      //   {key:"zone", values: zone?.values, value: zone?.value},
      //   {key:"pagetype",values: pagetype?.values, value: pagetype?.value},
      //   {key:"programmatic_ads",values:null,value:"true"},
      //   {key:"ads",values:null,value: "true"},
      //   {key:"channel",values:null,value:"mobile_app"}] 
      "targeting": props?.adInformation?.targeting
          ,dfpAdUrl : props.adInformation.dfpAdUrl
          ,clientAlias : props.adInformation.clientAlias
    })

    if(json && typeof json === 'string') {
      //json = json.replaceAll(':true', ':"true"').replaceAll(':false', ':"false"');
      json = json.replace(/:true/g, ':"true"').replace(/:false/g, ':"false"');
    }

    return json
  }, [props?.adInformation?.targeting])

  useEffect(() => {
    if(adsReady && !callbackFired && window.traffective && window.traffective.routeChangeStart) {
      try {
        window.traffective.routeChangeStart()
      } catch (error) {
        console.error('Error calling routeChangeStart:', error);
      }
    }
    if(cmpReady && traffectiveConf) {

      const trfAdSetup = document.getElementById('trfAdSetup')
      if(!trfAdSetup) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'trfAdSetup';
        script.async = true;
        script.src = process.env.NEXT_PUBLIC_TRAFFECTIVE_URL || '';
        
        script.setAttribute('data-traffectiveconf', traffectiveConf);

        document.head.appendChild(script);
      }
      else {
        trfAdSetup.setAttribute('data-traffectiveconf', traffectiveConf);
      }
    }
    if(adsReady && !callbackFired && window.traffective && window.traffective.routeChangeComplete) {
      try {
        window.traffective.routeChangeComplete()
        setCallbackFired(true)
      } catch (error) {
        console.error('Error calling routeChangeComplete:', error);
        // Still set callback as fired to prevent retries
        setCallbackFired(true)
      }
    }

  }, [cmpReady, traffectiveConf, adsReady])

  return null;
}
